import cn from "classnames";
import React from "react";

// Define Props using TypeScript interface
interface Props extends React.HTMLProps<HTMLTableSectionElement> {
  children?: React.ReactNode;
  className?: string;
}

const TableBody: React.FC<Props> = ({ className, children, ...props }) => {
  const classes = cn(className);
  return (
    <tbody className={classes} {...props}>
      {children}
    </tbody>
  );
};

export default TableBody;
